import React, { Children } from 'react';
import userGuide from '../../static/images/userguide.pdf';

const Sidebar = props => {

  return (
    <nav className="sidebar">    
      {
        Children.map(props.children, child => {
          return child
        })
      }

      <a className="sidebar__item" href={ userGuide } target="_blank" rel="noopener noreferrer" title="View the user manual">
        <i className="sidebar__icon fas fa-book-open"></i>
        <span className="sidebar__text">User manual</span>
      </a>
    </nav>
  );

}

export default Sidebar;
